import * as yup from 'yup';

export const REQUIRED_FIELD_MESSAGE_TEXT = 'is a required field';
export const requiredFieldMessage = (fieldName: string): string => `${fieldName} ${REQUIRED_FIELD_MESSAGE_TEXT}`;
export const maxLengthFieldMessage = (maxLength?: number): string => `Max length is ${maxLength}`;

export const createFormSchema = yup.object().shape({
  formItemNo: yup.string().required(requiredFieldMessage('Form/Item No.')).max(50, maxLengthFieldMessage(50)),
  formType: yup.string().required(requiredFieldMessage('Form Type')),
  description: yup.string().required(requiredFieldMessage('Description')).max(500, maxLengthFieldMessage(500)),
  policyTypeDescription: yup.string().when('formType', {
    is: 'Policy',
    then: yup.string().required(requiredFieldMessage('Policy Type')),
    otherwise: yup.string().nullable(),
  }),
  starsProductTypeCode: yup.string().max(50, maxLengthFieldMessage(50)).nullable(),
  coverageClass: yup.string().required(requiredFieldMessage('Coverage Class')),
  underwriter: yup.string().when('formType', {
    is: 'Policy',
    then: yup.string().required(requiredFieldMessage('Underwriter')),
    otherwise: yup.string().nullable(),
  }),
  isActive: yup.boolean().required(),
  states: yup.array().min(1, 'At least one state is required').required('At least one state is required'),
});
